module.exports = __webpack_public_path__ + "772d76c80ea4121c6c022b40f40445d4.jpg";